export default class Residencia {
    constructor(idResidencia, nome, status) {
        this.idResidencia = idResidencia
        this.nome = nome;
        this.status = status;
    }
  }